import { ChevronDownIcon, ChevronUpIcon } from "@heroicons/react/20/solid";
import {
  addDays,
  format,
  isSameDay,
  // getWeek,
  lastDayOfWeek,
  startOfWeek,
} from "date-fns";
import moment from "moment";
import React from "react";
import { Calendar } from "react-multi-date-picker";


export default function CalendarView({
  selectedDate,
  onDateClickHandle,
  eventDatesRange,
  eventDates,
}) {
  // eslint-disable-next-line no-unused-vars
  const [currentMonth, setCurrentMonth] = React.useState(new Date());
  // const [currentWeek, setCurrentWeek] = React.useState(getWeek(currentMonth));
  const [collapseOpen, setCollapseOpen] = React.useState(false);

  const renderDays = () => {
    const dateFormat = "EEE";
    const days = [];
    let startDate = startOfWeek(selectedDate ?? currentMonth, {
      weekStartsOn: 0,
    });
    for (let i = 0; i < 7; i++) {
      days.push(
        <div
          className={
            // "font-medium text-granite-gray text-sm sm:text-xs grid place-items-center w-9 h-9"
            "font-medium text-granite-gray text-sm grid place-items-center w-8 h-8"
          }
          key={i}
        >
          {format(addDays(startDate, i), dateFormat)}
        </div>
      );
    }
    return (
      <div className={"w-full flex flex-row justify-between gap-4 sm:gap-2 lg:gap-2"}>{days}</div>
    );
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const memoizedDays = React.useMemo(renderDays, [selectedDate]);

  const renderCells = () => {
    const startDate = startOfWeek(selectedDate ?? currentMonth, {
      weekStartsOn: 0,
    });
    const endDate = lastDayOfWeek(selectedDate ?? currentMonth, {
      weekStartsOn: 0,
    });
    const dateFormat = "d";
    const rows = [];
    let days = [];
    let day = startDate;
    let formattedDate = "";
    while (day <= endDate) {
      for (let i = 0; i < 7; i++) {
        formattedDate = format(day, dateFormat);
        // const cloneDay = day;
        days.push(
          <div
            className={`font-semibold text-base grid place-items-center ${isSameDay(day, selectedDate ?? new Date())
              ? "bg-portland-orange rounded-full text-white"
              : "text-light-brown-coffee"
              } w-8 h-8`}
            key={day}
          >
            <span>{formattedDate}</span>
          </div>
        );
        day = addDays(day, 1);
      }

      rows.push(
        <div className={"w-full flex flex-row justify-between gap-4 sm:gap-3 lg:gap-2"} key={day}>
          {days}
        </div>
      );
      days = [];
    }

    return <div className="w-full">{rows}</div>;
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const memoizedCells = React.useMemo(renderCells, [selectedDate]);


  return (
    <div className={"bg-white border border-lilac rounded-xl py-2 px-6 w-full flex justify-center items-center"}>
      <div className={"cursor-pointer inline-block"} onClick={() => setCollapseOpen(true)}>
        <div
          className={`${collapseOpen === false ? "block" : "hidden"
            } flex flex-row items-center justify-between gap-2`}
        >
          {memoizedDays}
          <ChevronUpIcon className="size-7" />
        </div>
        <div
          className={`${collapseOpen === false ? "block" : "hidden"
            } flex flex-row items-center justify-between gap-2`}
        >
          {memoizedCells}
          <ChevronDownIcon className="size-7" />
        </div>
      </div>
      <div
        className={`${collapseOpen === true ? "flex" : "hidden"}`}
      >
        <Calendar
          className="bookzy-calendar bookzy-border default-today"
          value={moment(selectedDate).toDate()}
          weekDays={["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"]}
          onChange={(selectedDates) => {
            console.log("dates", selectedDates.toDate());
            onDateClickHandle(selectedDates);
            setCollapseOpen(false);
            return false;
          }}
        // style={{
        //   backgroundColor: "text-brown-coffee",
        //   // height: "24px",
        //   borderRadius: "8px",
        //   fontSize: "24px",
        //   padding: "3px 10px"
        // }}
        />
      </div>
    </div>
  );
}
